<div class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full bg-opacity-60 overflow-auto">
  <div class="bg-white rounded-lg w-full lg:w-2/3 xl:1/2 h-full overflow-auto">
    <div class="flex flex-col items-start p-4">
      <div class="flex items-center justify-between w-full">
        <div class="text-gray-900 font-medium text-lg mb-4 mt-4">{{ title }}</div>
        <div class="flex flex-row justify-end text-gray-700 cursor-pointer" (click)="close()">
          <span class="mr-1 hidden md:block">Sluit dit artikel</span>
          <svg class="ml-auto fill-current w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
            <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"/>
          </svg>
        </div>
      </div>
      <hr>
      <div class="overflow-auto w-full mb-20">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
